import { css } from '@emotion/react';
type Props = { color?: string };
export default ({ color = 'var(--primary)' }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99432 8.50334C7.21027 8.79233 7.48578 9.03144 7.80216 9.20447C8.11854 9.3775 8.4684 9.48039 8.828 9.50617C9.1876 9.53195 9.54853 9.48002 9.88632 9.35389C10.2241 9.22775 10.5308 9.03038 10.7857 8.77515L12.2942 7.26512C12.7522 6.79046 13.0056 6.15473 12.9999 5.49485C12.9942 4.83498 12.7298 4.20375 12.2636 3.73713C11.7975 3.27051 11.1669 3.00583 10.5077 3.0001C9.84844 2.99436 9.21335 3.24803 8.73917 3.70647L7.87429 4.56719M9.00568 7.49666C8.78973 7.20767 8.51422 6.96856 8.19784 6.79553C7.88146 6.6225 7.5316 6.51961 7.172 6.49383C6.8124 6.46805 6.45147 6.51998 6.11368 6.64611C5.77589 6.77224 5.46916 6.96962 5.21428 7.22485L3.70576 8.73488C3.24778 9.20954 2.99437 9.84527 3.0001 10.5051C3.00582 11.165 3.27024 11.7962 3.73639 12.2629C4.20254 12.7295 4.83313 12.9942 5.49234 12.9999C6.15156 13.0056 6.78665 12.752 7.26083 12.2935L8.12068 11.4328"
        stroke="#262626"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
